export default __webpack_public_path__ + "static/app-store-f23b95fc1856684d6692e455a81b3066.svg";